<script lang="ts">
    import { onMount } from "svelte";

    import { APIHelper } from "../code/APIHelper";
    import DBG from "../code/DBG";
    import Helpers from "../code/Helpers";

    let licenceTypes = [
        {
            value: "YearlySingle",
            text: "1 year, 1 user",
        },
        {
            value: "MonthlySingle",
            text: "1 month, 1 user",
        },
        {
            value: "YearlyThree",
            text: "1 year, 3 users",
        },
        {
            value: "MonthlyThree",
            text: "1 month, 3 users",
        },
    ];

    let email: string;
    let company: string;
    let name: string;
    let licence: string;

    let errorMessage: string = undefined;
    let successMessage: string = undefined;
    let createdUser: string = undefined;
    function callAPI() {
        errorMessage = undefined;
        successMessage = undefined;
        APIHelper.createUser(email, name, licence, company).then((res) => {
            DBG.log("AdminPage - create user returned", res);
            if (res.error) {
                errorMessage = res.error;
            } else {
                successMessage = "User created";
                createdUser = JSON.stringify(res);
            }
        });
    }

    function nameEdited() {
        DBG.log("AdminPage - name edited");
        if (!email && name) {
            let parts = name.toLowerCase().split(" ");
            email = parts.join(".") + "@tlmsp.com";
        }
    }

    let authUser = undefined;
    onMount(() => {
        DBG.log("AdminPage - getting admin user");
        APIHelper.getUserFromAPI().then((res) => {
            DBG.log("AdminPage - getting admin user result", res);
            authUser = res;
        });
    });

    function login(){
        window.location.href = "/signin";
    }

    function testRegistration() {
        let step = 4;
        let testPassword = "Pass@word2";
        let testUser = "test.g1@geanica.com";
        switch (step) {
            case 1:
                // #1 Register
                Helpers.HashString(testPassword).then((pass) => {
                    APIHelper.callApiEntry({
                        op: "register",
                        user: testUser,
                        passHash: pass,
                    }).then((res) => {
                        DBG.log("AdminPage - testRegistration - register", res);
                    });
                });

                break;
            case 2:
                // #2 Login
                Helpers.HashString(testPassword).then((pass) => {
                    APIHelper.callApiEntry({
                        op: "login",
                        user: testUser,
                        passHash: pass,
                    }).then((res) => {
                        DBG.log("AdminPage - testRegistration - register", res);
                    });
                });
                break;
            case 3:
                // #3 ResetPass
                APIHelper.callApiEntry({
                    op: "reset_pass_step1",
                    user: testUser,
                }).then((res) => {
                    DBG.log(
                        "AdminPage - testRegistration - reset_pass_step1",
                        res
                    );
                });
                break;
            case 4:
                // #4 ResetPass with email code
                Helpers.HashString(testPassword).then((pass) => {
                    APIHelper.callApiEntry({
                        op: "reset_pass_step2",
                        user: testUser,
                        resetCode:
                            "a73511057a5057297c2f555c7ac79eedf68addd7e9a29d7a8953416443474829",
                        passHash: pass,
                    }).then((res) => {
                        DBG.log(
                            "AdminPage - testRegistration - reset_pass_step2",
                            res
                        );
                    });
                });

                break;
        }
    }
</script>

<div class="col-6">
    {#if authUser}
    <div class="mb-3">
        
        <strong>Logged on User:</strong> {authUser.rowKey}
    </div>
    <div class="form-floating mb-3">
        <input
            bind:value={name}
            type="text"
            class="form-control"
            id="userName"
            on:blur={nameEdited}
            placeholder="John Doe"
        />
        <label for="userName">Name</label>
    </div>
    <div class="form-floating mb-3">
        <input
            bind:value={email}
            type="email"
            class="form-control"
            id="userEmail"
            placeholder="name@example.com"
        />
        <label for="userEmail">Email address</label>
    </div>

    <div class="form-floating mb-3">
        <input
            bind:value={company}
            type="text"
            class="form-control"
            id="userCompany"
            placeholder="Bimart"
        />
        <label for="userCompany">Company</label>
    </div>
    <div class="form-floating">
        <select
            bind:value={licence}
            class="form-select"
            id="selLicence"
            aria-label="Floating label select example"
        >
            {#each licenceTypes as lic}
                <option value={lic.value}>{lic.text}</option>
            {/each}
        </select>
        <label for="selLicence">Licence</label>
    </div>
    <button on:click={callAPI} type="button" class="btn btn-primary"
        >Add user</button
    >
    {:else}
    <p>You need to be logged in as an admin to use this section</p>
    <button on:click={login} type="button" class="btn btn-primary"
    >Login</button
>
    {/if}

    {#if errorMessage}
        <dir class="error-message">
            {errorMessage}
        </dir>
    {/if}
    {#if successMessage}
        <dir class="success-message">
            {successMessage}
        </dir>
        <p>{createdUser}</p>
    {/if}
    <!--
    <button on:click={testRegistration} type="button" class="btn btn-primary"
        >TEST Registration</button
    >-->
</div>

<style>
    .error-message {
        font-size: 2rem;
        color: red;
        font-weight: bold;
    }
    .success-message {
        font-size: 2rem;
        color: green;
        font-weight: bold;
    }
</style>
